import React, { useState } from 'react';
import style from '../css/VideoTrailer.module.css';

import VideoModal from './modals/VideoModal';

import trailer from '../images/video-trailer.png';

import { BsFillPlayFill } from 'react-icons/bs';

const VideoTrailer = () => {
	const [openModal, setOpenModal] = useState(false);

	const handlerClose = () => {
		setOpenModal(false);
	};

	return (
		<section className={style.sectionMain}>
			<div className={style.mainContainer}>
				<div className={style.playButton} onClick={() => setOpenModal(true)}>
					<BsFillPlayFill />
				</div>
				<img src={trailer} alt='trailer' />
				<VideoModal
					modal={openModal}
					url={'https://www.youtube.com/watch?v=4M4LZ3xt-RA'}
					handlerClose={handlerClose}
				/>
			</div>
		</section>
	);
};

export default VideoTrailer;
